import { apiFetch, getCurrentUser } from './index.js';/**
 * Obtener todos los servicios de Inter
 */
export const obtenerInterServicios = async () => {
  try {
    const response = await apiFetch('/InterServicio');
    return {
      success: true,
      data: response,
      message: 'Servicios obtenidos exitosamente'
    };
  } catch (error) {
    console.error('❌ Error obteniendo servicios Inter:', error);
    return {
      success: false,
      error: error.message,
      data: []
    };
  }
};

/**
 * Obtener un servicio Inter por ID
 */
export const obtenerInterServicioPorId = async (id) => {
  try {
    const response = await apiFetch(`/InterServicio/${id}`);
    return {
      success: true,
      data: response
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Crear un nuevo servicio Inter
 */
export const crearInterServicio = async (data) => {
  try {
    const response = await apiFetch('/InterServicio', {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return {
      success: true,
      data: response,
      message: 'Servicio Inter registrado correctamente'
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Actualizar un servicio Inter
 */
export const actualizarInterServicio = async (id, data) => {
  try {
    const response = await apiFetch(`/InterServicio/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ ...data, idInterServicio: id })
    });
    return {
      success: true,
      data: response,
      message: 'Servicio Inter actualizado correctamente'
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Cambiar el estado de un servicio Inter
 */
export const cambiarEstadoInterServicio = async (id, nuevoEstado) => {
  try {
    await apiFetch(`/InterServicio/${id}/estado`, {
      method: 'PATCH',
      body: JSON.stringify(nuevoEstado)
    });
    return {
      success: true,
      message: 'Estado actualizado correctamente'
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Eliminar un servicio Inter
 */
export const eliminarInterServicio = async (id) => {
  try {
    await apiFetch(`/InterServicio/${id}`, {
      method: 'DELETE'
    });
    return {
      success: true,
      message: 'Servicio eliminado correctamente'
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Registrar pago en Caja
 */
export const registrarPagoCaja = async (servicio, pagoData) => {
    try {
        const currentUser = getCurrentUser();
        if (!currentUser || !currentUser.idUsuario) {
            return { success: false, message: 'Usuario no autenticado' };
        }

        const movimientoCaja = {
            tipoMovimiento: "Ingreso",
            montoUsd: pagoData.monto,
            montoBs: pagoData.monedaOriginal === 'VES' ? pagoData.montoOriginal : 0,
            descripcion: `Cobro de servicio Inter: ${servicio.planContratado || servicio.idInterServicio} - Cliente: ${servicio.nombreCliente} - Método: ${pagoData.metodo} (Ref: ${pagoData.referencia || 'N/A'})`,
            fechaMovimiento: new Date().toISOString(),
            idUsuario: currentUser.idUsuario
        };

        const res = await apiFetch('/MovimientoCaja', {
            method: 'POST',
            body: JSON.stringify(movimientoCaja)
        });
        
        return { success: true, data: res };
    } catch (error) {
        console.error("Error registrando pago en caja:", error);
        return { success: false, message: error.message };
    }
};
